import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  type ClientTheme,
  Theme,
  type ThemeState,
} from '@/features/theme/types/theme';

const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: Theme.LIGHT,
      clientTheme: undefined,
      toggleTheme: (): void => {
        set((state) => {
          const newTheme =
            state.theme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT;
          return {
            theme: newTheme,
          };
        });
      },
      setClientTheme: (clientTheme: ClientTheme): void => {
        set(() => {
          return {
            clientTheme: clientTheme,
          };
        });
      },
    }),
    {
      name: 'theme',
    },
  ),
);

export default useThemeStore;
